import { Link } from 'react-router-dom';
import { Activity, ScanLine, CalendarPlus, Footprints } from 'lucide-react';

const actions = [
  {
    to: '/run/start',
    title: 'Start Personal Run',
    desc: 'Track a solo run. No verification, just data.',
    icon: Footprints,
    accent: 'bg-primary text-primary-foreground',
    testid: 'create-personal-run',
  },
  {
    to: '/events/new',
    title: 'Create Event',
    desc: 'Set up a community or official race.',
    icon: CalendarPlus,
    accent: 'bg-foreground text-background',
    testid: 'create-event',
  },
  {
    to: '/scanner/activate',
    title: 'Activate Scanner',
    desc: 'Enable medal validation at the finish line.',
    icon: ScanLine,
    accent: 'bg-secondary text-secondary-foreground border border-border',
    testid: 'create-activate-scanner',
  },
];

export default function MobileCreate() {
  return (
    <div className="px-4 pt-4 pb-6 space-y-5" data-testid="create-screen">
      <div>
        <p className="rivl-label">Create</p>
        <h1 className="font-display text-3xl font-bold tracking-tight mt-1">What's the move?</h1>
      </div>
      <div className="space-y-3">
        {actions.map((a) => (
          <Link
            key={a.to}
            to={a.to}
            data-testid={a.testid}
            className="flex items-center gap-4 rivl-card p-5 hover:border-primary transition-colors"
          >
            <div className={`h-12 w-12 rounded-md flex items-center justify-center ${a.accent}`}>
              <a.icon className="h-6 w-6" />
            </div>
            <div className="flex-1">
              <div className="font-display text-lg font-semibold tracking-tight leading-tight">{a.title}</div>
              <div className="text-xs text-muted-foreground mt-1">{a.desc}</div>
            </div>
            <Activity className="h-4 w-4 text-muted-foreground" />
          </Link>
        ))}
      </div>
    </div>
  );
}
